import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import axios from 'axios';
// const querystring = require('querystring');
export default class ManageCalendar extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
				let parms = "";
// 				JSON.stringify(querystring.parse(this.props.location.search)).replace('?', '');
        console.log("parms => " + parms);

		this.state={
			"calendar" : {
					"calendarId": JSON.parse(parms).id,
				  "calendarName": "",
				  "ownerUserId": 0,
				  "securityContextId": 0,
				  "calendarStatusCode": 0,
				  "calendarDescr": "",
				  "calendarEntry": "",
				  "calendarAlertFlag": true,
				  "calendarReminderFlag": true,
				  "calendarAttachments": "",
				  "calendarParticipants": "",
				  "calendarEntryDate": new Date(),
				  "effectiveDate": new Date(),
				  "expirationDate": new Date(),
				  "createUser": 0,
				  "createDate": new Date(),
				  "lastUpdateUser": 0,
				  "lastUpdateDate": new Date()
				  },
				  	"calendarOwnerName" : "",
					"createUserName" : "",
				  	"lastUpdateUserName" : "",
				  calendarStatusCodeList : []
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleOnLoad = this.handleOnLoad.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}
	handleChange(event) {
		console.log(event);
		var target = event.target;
		console.log(target.id + ":" + target.value);
		this.setState({
			[target.id] : target.value
		});
	   
		console.log(this.state);
	  }
	handleSubmit(event) {

		event.preventDefault();
		console.log('handling submit');  
	
	  var url = `${global.config.apiServicesUrl}/calendars`;
//	  var idUrl = "${global.config.securityServicesUrl}/next-id-generator/get-next/calendars/calendarId";
	
//	  axios.get(idUrl)
//		  .then(response => {
//			  this.setState({generalledgerId : response.data["nextId"]});
//		  
//			  //console.log("new category id = " + JSON.stringifyt(this.state.calendar.contentCategoriesObject.contentCategoryId));
//		
//			console.log("request object = " + JSON.stringify(this.state));
	  		this.state.calendar.lastUpdateUser = Number(this.props.userId);

			axios
			  .post(url, this.state)
			  .then(response2 => {
			console.log("response.data");
			console.log(response2.status +":"+response2.data.accountId);
			// && response2.data.contentFacadeId === this.state.calendar.contentFacadeId
			if (response2.status === 200 )
			{
				this.message = "Success";
			}
			else
			{
				 this.message = "Failed";
			}        
			console.log(this.message);
			 // 
			event.preventDefault();
			//response.send(this.message);
			
		  })
			  .catch(err => {
			 console.log("error - " + err);
		  });
			  console.log("message info - " + this.message); 
		this.handleClear();
			
		//});
		
		
			console.log("SetState Message info-"+this.contentFacadeTypeId);
			console.log("SetState Message info-"+this.contentFacadeName);
			
	 };
	 handleClear(){
		 this.setState({calendar : {}})
	 }
	 componentDidMount() 
	 {
	 	this.handleOnLoad();
	 }

	handleOnLoad = () => {
      axios.get(`${global.config.apiServicesUrl}/vlm-calendars/${this.state.calendar.calendarId}`).then(res => {

	      	this.setState({ calendar : res.data });
    	  	console.log(res.data[0]);

      		//this.setState({calendar : {}});
    		//resolve drop down lists
			{
				//taskPriorityList
				var url1 = `${global.config.sharedServicesUrl}/code-catalog-data-service/get-system-code-values/JOURNAL_STATUS_CODE`;
					axios.get(url1)
					.then(response =>{
 					this.setState({calendarStatusCodeList : response.data});
					}).catch(function (error) {
						console.log("Error:"+error);
					});		
			}      	
      		//resolve user names			
				 {
					axios.get(`${global.config.securityServicesUrl}/user-profile-service/userprofile/username/${this.state.calendar.createUser}`)
					.then(response =>{
 					this.setState({createUserName : response.data});
					}).catch(function (error) {
						console.log("Error:"+error);
					});		
					axios.get(`${global.config.securityServicesUrl}/user-profile-service/userprofile/username/${this.state.calendar.lastUpdateUser}`)
					.then(response =>{
 					this.setState({lastUpdateUserName : response.data});
					}).catch(function (error) {
					console.log("Error:"+error);
					});		
					axios.get(`${global.config.securityServicesUrl}/user-profile-service/userprofile/username/${this.state.calendar.ownerUserId}`)
					.then(response =>{
 					this.setState({calendarOwnerName : response.data});
					}).catch(function (error) {
					console.log("Error:"+error);
					});		
				}


				
				
		})
		.catch(function (error){
		})
	 }

	 handleDelete(event){
	 	event.preventDefault();
 	 	//alert(`deleting posting with id = ${this.state.blog.blogId}`);
		axios.delete(`${global.config.apiServicesUrl}/blogs/${this.state.calender.calendarId}`).then(res => {
  		this.handleClear();
		window.location.href = "/calendar";
  		});
  	}
  		
  			
	render(){
    return (
        				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<Link to="/" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</Link>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<Link to="/" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</Link>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="#" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
		
		<form>
		<div class="container-fluid">
		<h4>Manage Calendar Entry</h4>
		<hr />
		

		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Calendar Name</label>
		<input id="calendarName" class="form-control input-medium col-sm-8" value={this.state.calendar.calendarName} onChange ={this.handleChange}/>
		</div>
			<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Calendar Owner</label>
		<input id="ownerUserId" class="form-control input-medium col-sm-8" value={this.state.calendarOwnerName} onChange ={this.handleChange}/>
		</div>

			<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Calendar Status</label>
			<select id="calendarStatusCode" class="form-control input-medium col-sm-8" value={this.state.calendar.calendarStatusCode} onChange ={this.handleChange}>
			{
				this.state.calendarStatusCodeList.map((status) => {
					return (
						<option key={status.systemCodeValueId} value={status.systemCodeValueId}>{status.systemCodeValueValue}</option>
					)
				})
			}
			</select>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Description</label>
			<input id="calendarDescr" class="form-control input-medium col-sm-8" value={this.state.calendar.calendarDescr} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Calendar Entry</label>
			<input id="calendarEntry" class="form-control input-medium col-sm-8" value={this.state.calendar.calendarEntry} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Alert Flag</label>
			<input id="calendarAlertFlag" class="form-control input-medium col-sm-8" value={this.state.calendar.calendarAlertFlag} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Calendar Reminder Flag</label>
			<input id="calendarReminderFlag" class="form-control input-medium col-sm-8" value={this.state.calendar.calendarReminderFlag} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Attachments</label>
			<select id="calendarAttachments" class="form-control input-medium col-sm-8" value={this.state.calendar.calendarAttachments} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Participants</label>
			<select id="calendarParticipants" class="form-control input-medium col-sm-8" value={this.state.calendar.calendarParticipants} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Entry Date</label>
			<input id="calendarEntryDate" class="form-control input-medium col-sm-8" value={String(this.state.calendar.calendarEntryDate).substring(0,10)} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Effective Date</label>
			<input id="effectiveDate" class="form-control input-medium col-sm-8" value={String(this.state.calendar.effectiveDate).substring(0,10)} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Expiration Date</label>
			<input id="expirationDate" class="form-control input-medium col-sm-8" value={String(this.state.calendar.expirationDate).substring(0,10)} onChange ={this.handleChange}/>
			</div>

		

				<hr/>
							<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Created By</label>
		<input id="createUserName" class="form-control input-medium col-sm-2" value={this.state.createUserName} />
		<label class="ContentTitle col-sm-1" > On </label>
		<input id="createDate" class="form-control input-medium col-sm-2" value={String(this.state.calendar.createDate).substring(0,10)} />
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Last Updated By</label>
		<input id="lastUpdateUserName" class="form-control input-medium col-sm-2" value={this.state.lastUpdateUserName} />
		<label class="ContentTitle col-sm-1" > On </label>
		<input id="lastUpdateDate" class="form-control input-medium col-sm-2" value={String(this.state.calendar.lastUpdateDate).substring(0,10)} />
		</div>
		<hr />	
					
					<button class="btn btn-primary" value="Clear" onClick ={this.handleClear}>Clear</button> &nbsp;
					<button class="btn btn-success" value="Save" onClick ={this.handleSubmit}>Save</button>&nbsp;
					<button class="btn btn-danger" value="Delete" onClick ={this.handleDelete}>Delete</button> 
		</div>		
		</form>
						</div>		

	            </div>	
            </div>
            
			</div>
			</div>
	);
}
}